
import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      isExpanded: false,
      isMobile: false,
      fullText:
        'Svarbiausios dienos naujienos ir įdomiausios istorijos – tiesiai į jūsų el. pašto dėžutę. Be informacinio triukšmo, tik tai, kas atrinkta ir verta jūsų laiko. Prenumeruokite jus dominančias temas – nuo svarbiausių Lietuvos ir pasaulio įvykių iki įkvepiančių gyvenimo būdo, sveikatos ar laisvalaikio idėjų. Norėdami gauti dominančių autorių ar temų naujienlaiškius, spauskite „Užsakyti“ prie pasirinktų naujienlaiškių. Pasirinkimus bet kada galėsite keisti. Informacija apie tai, kaip „Delfi“ tvarko jūsų duomenis, pateikta <a href="https://www.delfi.lt/apie/privatumas/">Privatumo politikoje</a>.',
    };
  },
  computed: {
    firstSentence(): string {
      const first = this.fullText.split('.')[0];
      return first ? first + '.' : this.fullText;
    },
  },
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
  },
});
